import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DispositivoOnboarding, EstadoOnboardingPainel, OnboardingPainelService} from '../onboarding-painel.service';
import {OnbFocoService} from '../apoio/onb-foco.service';

/**
 * Passo 5 · Onde você recebe os pedidos. Aparelho, som testado de verdade e aviso na tela. No computador entram os
 * equipamentos (extensão do WhatsApp e impressora). Ao salvar, Pedidos entra no menu.
 */
@Component({
  selector: 'app-passo-receber',
  templateUrl: './passo-receber.component.html',
  styleUrls: ['./passo-receber.component.scss']
})
export class PassoReceberComponent implements OnInit, OnDestroy {
  @Input() estado: EstadoOnboardingPainel;
  @Output() concluido = new EventEmitter<EstadoOnboardingPainel>();
  @Output() atualizou = new EventEmitter<EstadoOnboardingPainel>();
  @Output() ajuda = new EventEmitter<{motivo: string; passo: string}>();

  dispositivo: DispositivoOnboarding | null = null;
  somTestado = false;
  notificacao = false;
  notificacaoNegada = false;
  salvando = false;
  erro = '';
  readonly telaDeComputador = typeof window !== 'undefined' && window.innerWidth >= 1024 && !/Android|iPhone|iPad|Mobile/i.test(navigator.userAgent);
  private audio: AudioContext | null = null;

  constructor(private onboarding: OnboardingPainelService, private foco: OnbFocoService) {}

  ngOnInit(): void {
    this.dispositivo = this.estado?.dispositivo || (this.telaDeComputador ? 'COMPUTADOR' : 'CELULAR');
    this.somTestado = !!this.estado?.passos?.find(p => p.id === 'receber')?.feito;
    this.notificacao = !!this.estado?.equipamentos?.notificacao || this.permissaoAtual() === 'granted';
  }

  ngOnDestroy(): void { if (this.audio) this.audio.close().catch(() => {}); }

  private permissaoAtual(): string {
    try { return (window as any).Notification ? (window as any).Notification.permission : 'unsupported'; } catch (e) { return 'unsupported'; }
  }

  get suportaNotificacao(): boolean { return this.permissaoAtual() !== 'unsupported'; }

  get mostraEquipamentos(): boolean { return this.dispositivo === 'COMPUTADOR' && this.telaDeComputador; }

  get computadorLonge(): boolean { return this.dispositivo === 'COMPUTADOR' && !this.telaDeComputador; }

  escolha(d: DispositivoOnboarding): void { this.dispositivo = d; }

  /** O mesmo toque de pedido novo, tocado na hora para o dono ajustar o volume. */
  testeSom(): void {
    try {
      const Contexto = (window as any).AudioContext || (window as any).webkitAudioContext;
      this.audio = this.audio || new Contexto();
      if (this.audio.state === 'suspended') this.audio.resume();
      const t = this.audio.currentTime;
      [[880, 0], [1175, .16], [880, .42], [1175, .58]].forEach(([freq, atraso]) => {
        const osc = this.audio.createOscillator(), ganho = this.audio.createGain();
        osc.type = 'sine';
        osc.frequency.value = freq;
        ganho.gain.setValueAtTime(0, t + atraso);
        ganho.gain.linearRampToValueAtTime(.25, t + atraso + .02);
        ganho.gain.exponentialRampToValueAtTime(.001, t + atraso + .2);
        osc.connect(ganho).connect(this.audio.destination);
        osc.start(t + atraso);
        osc.stop(t + atraso + .22);
      });
    } catch (e) {}
    this.somTestado = true;
  }

  permitaNotificacao(): void {
    const N = (window as any).Notification;
    if (!N) return;
    N.requestPermission().then((resposta: string) => {
      this.notificacao = resposta === 'granted';
      this.notificacaoNegada = resposta === 'denied';
      if (this.notificacao) {
        try { new N('MeuCardápio', {body: 'Pronto! Você vai ver aqui quando chegar pedido.'}); } catch (e) {}
        this.onboarding.confirme('notificacao').catch(() => {});
      }
    });
  }

  salve(): void {
    if (this.salvando) return;
    if (!this.dispositivo) return this.foco.mostre('onb-aparelhos', 'Escolha onde você vai receber os pedidos.');
    if (!this.somTestado) return this.foco.mostre('onb-testar-som', 'Toque aqui para ouvir o som de pedido novo e ajustar o volume.');
    this.salvando = true;
    this.erro = '';
    this.onboarding.confirme('receber', {dispositivo: this.dispositivo}).then(estado => this.concluido.emit(estado))
      .catch(e => this.erro = OnboardingPainelService.mensagem(e))
      .finally(() => this.salvando = false);
  }
}
